import { motion } from "framer-motion";
import { FiArrowRight, FiArrowUpRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { categories } from "../../data/fakeData";

const CategorySection = () => (
  <section className="section-white">
    <div className="container-main py-20 lg:py-24">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12"
      >
        <div>
          <div className="accent-line" style={{ backgroundColor: "#7c3aed" }} />
          <p className="label-tag mb-2" style={{ color: "#7c3aed" }}>
            Browse Topics
          </p>
          <h2 className="section-title">Explore by Category</h2>
          <p className="section-subtitle">
            Dive into {categories.length} curated categories. Each one features
            the top-rated websites.
          </p>
        </div>
        <Link to="/categories" className="btn-ghost flex-shrink-0">
          All categories <FiArrowRight size={14} />
        </Link>
      </motion.div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {categories.slice(0, 8).map((cat, i) => (
          <motion.div
            key={cat.id}
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.04 }}
          >
            <Link
              to={`/category/${cat.slug}`}
              className="group relative block rounded-2xl overflow-hidden border-2 border-slate-100 hover:border-indigo-200 transition-all duration-300 shadow-sm hover:shadow-md"
            >
              {/* Photo */}
              <div className="relative h-28 overflow-hidden">
                <img
                  src={cat.photo}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                {/* Color strip at top */}
                <div
                  className="absolute top-0 left-0 right-0 h-0.5"
                  style={{ backgroundColor: cat.color }}
                />
                {/* Arrow icon */}
                <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-6 h-6 bg-white/90 rounded-md flex items-center justify-center">
                    <FiArrowUpRight size={11} className="text-slate-700" />
                  </div>
                </div>
              </div>

              {/* Info bar */}
              <div className="bg-white px-3 py-2.5 flex items-center justify-between">
                <div className="min-w-0">
                  <h3 className="text-xs font-bold text-slate-900 group-hover:text-indigo-700 transition-colors truncate">
                    {cat.name}
                  </h3>
                  <p className="text-[10px] text-slate-400 font-semibold">
                    {cat.count} sites
                  </p>
                </div>
                <div
                  className="w-2 h-2 rounded-full flex-shrink-0 ml-2"
                  style={{ backgroundColor: cat.color }}
                />
              </div>
            </Link>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="text-center mt-8"
      >
        <Link to="/categories" className="btn-secondary">
          View all {categories.length} categories <FiArrowRight size={14} />
        </Link>
      </motion.div>
    </div>
  </section>
);

export default CategorySection;
